import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = mobileOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [mobileOpen]);

  const handleLinkClick = () => setMobileOpen(false);

  return (
    <>
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-md border-b border-gray-200 shadow-sm' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="flex items-center justify-between h-20">
            <Link to="/" className="flex items-center gap-2 sm:gap-3 group cursor-pointer">
              <img
                src="https://public.readdy.ai/ai/img_res/35bb13ed-42dd-4e6d-9219-49cd23ae6a25.png"
                alt="BR Webdesign & AI Solutions Logo"
                className="w-9 h-9 sm:w-12 sm:h-12 object-contain flex-shrink-0"
                loading="lazy"
                decoding="async"
                width={48}
                height={48}
              />
              <div className="flex flex-col leading-tight">
                <span className="text-sm sm:text-lg font-caprasimo text-brand-black group-hover:text-brand-green-light transition-colors whitespace-nowrap">
                  BR Webdesign
                </span>
                <span className="text-[8px] sm:text-[10px] font-semibold text-brand-grey tracking-wider uppercase whitespace-nowrap">& AI Solutions</span>
              </div>
            </Link>

            <div className="hidden md:flex items-center gap-8">
              {[
                { to: '/', label: 'Startseite' },
                { to: '/services', label: 'Leistungen' },
                { to: '/portfolio', label: 'Portfolio' },
                { to: '/pricing', label: 'Preise' },
                { to: '/about', label: 'Über mich' },
                { to: '/contact', label: 'Kontakt' },
              ].map(({ to, label }) => (
                <Link
                  key={to}
                  to={to}
                  className={`hover:text-brand-green transition-colors cursor-pointer ${isScrolled ? 'text-brand-black' : 'text-white'}`}
                >
                  {label}
                </Link>
              ))}
            </div>

            <div className="flex items-center gap-4">
              <a
                href="tel:01623651571"
                className={`hidden md:flex items-center gap-2 text-sm transition-colors cursor-pointer whitespace-nowrap ${isScrolled ? 'text-brand-black hover:text-brand-green' : 'text-white/90 hover:text-white'}`}
              >
                <i className="ri-phone-line" />
                0162 365 1571
              </a>
              <Link
                to="/contact"
                className="hidden md:block bg-brand-green hover:bg-brand-green-light text-white px-6 py-2.5 rounded-lg text-sm font-semibold transition-all cursor-pointer whitespace-nowrap relative z-50"
              >
                Jetzt anfragen
              </Link>

              <button
                onClick={() => setMobileOpen(!mobileOpen)}
                className={`md:hidden w-11 h-11 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${
                  isScrolled ? 'text-brand-black hover:bg-gray-100' : 'text-white hover:bg-white/10'
                }`}
                aria-label="Menü öffnen"
              >
                <i className={`text-2xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`} />
              </button>
            </div>
          </div>
        </div>
      </nav>

      {mobileOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 md:hidden"
          onClick={() => setMobileOpen(false)}
        />
      )}

      <div
        className={`fixed top-20 left-0 right-0 bg-white border-b border-gray-200 shadow-lg z-40 md:hidden transition-transform duration-300 ${
          mobileOpen ? 'translate-y-0' : '-translate-y-full'
        }`}
      >
        <div className="px-4 py-6 space-y-1">
          {[
            { to: '/', label: 'Startseite' },
            { to: '/services', label: 'Leistungen' },
            { to: '/portfolio', label: 'Portfolio' },
            { to: '/pricing', label: 'Preise' },
            { to: '/about', label: 'Über mich' },
            { to: '/contact', label: 'Kontakt' },
          ].map(({ to, label }) => (
            <Link
              key={to}
              to={to}
              onClick={handleLinkClick}
              className="block px-4 py-3 text-base font-medium text-brand-black hover:bg-gray-50 hover:text-brand-green rounded-lg transition-colors cursor-pointer"
            >
              {label}
            </Link>
          ))}

          <div className="pt-4 border-t border-gray-200 mt-4">
            <a
              href="tel:01623651571"
              className="flex items-center justify-center gap-2 px-4 py-3 text-base font-medium text-brand-black hover:bg-gray-50 rounded-lg transition-colors cursor-pointer"
            >
              <i className="ri-phone-line" />
              0162 365 1571
            </a>
            <Link
              to="/contact"
              onClick={handleLinkClick}
              className="block w-full mt-2 bg-brand-green hover:bg-brand-green-light text-white text-center px-6 py-3 rounded-lg text-base font-semibold transition-all cursor-pointer"
            >
              Jetzt anfragen
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
